import { useEffect } from "react";
import ProfileImg from "../images/about_img.jpg";
import { Page, changePageState } from "../Interfaces";

const About = ({ setCurrentPage }: changePageState) => {
  useEffect(() => setCurrentPage(Page.about), [setCurrentPage]);
  return (
    <div className="about">
      <div className="about__img flex">
        <img src={ProfileImg} alt="" />
      </div>
      <div className="about__description">
        <h2 className="about__description__heading">About</h2>
        <p className="about__description__p">
         Hi 👋, I'm Aayush Musyaju. I am a computer engineering graduate driven by a deep passion and curiosity for technology. My journey began with a fascination for computers, inspiring me to pursue a bachelor's degree in computer engineering. Throughout my studies, I discovered a love for programming and the excitement of learning something new every day.
         <br />
         <br />
         I thrive on tackling challenges, crafting innovative solutions, and building products that make a meaningful impact in people's lives. My interests span a wide range of computer-related fields, including deep learning and cybersecurity. I'm genuinely captivated by everything connected to computers.
         <br />
         <br />
         Beyond the technical realm, I enjoy reading manga, watching anime, and sketching anime characters in my free time.
        </p>
      </div>
    </div>
  );
};

export default About;
